<template>
  <span class="status-badge" :style="{ background: meta.bg, color: meta.fg }">
    <span class="status-dot" :style="{ background: meta.dot }"></span>{{ meta.label }}
  </span>
</template>

<script>
import { STATUS_META } from '@/utils/clinic-settlements.utils';

// Estado financiero de una liquidación, con los colores del diseño de Facturación de Clínicas.
export default {
  name: 'SettlementStatusBadge',
  props: {
    status: { type: String, default: 'not_invoiced' }
  },
  computed: {
    meta() {
      return STATUS_META[this.status] || STATUS_META.not_invoiced;
    }
  }
};
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
}
</style>
